import { sessionBloc } from '@bloc/SessionBloc';
import classNames from 'classnames';
import * as React from 'react';
import AdminRouter from 'src/AdminRouter';
import Page403 from 'src/pages/Page403';
import Navbar from './Navbar';

export interface IManagementLayoutProps {
}

export default class ManagementLayout extends React.Component<IManagementLayoutProps, any> {

  constructor(props) {
    super(props);
    this.state = {
      minimize: false
    }
  }
  public render() {
    if (!(sessionBloc.isAdminOrResponsible() || sessionBloc.isOrdonnanceur() || sessionBloc.isCoordinateur())) return <Page403/>
    return (
      <div className={classNames({"base-app": true, "minimize": this.state.minimize})}>
        <Navbar router={AdminRouter(sessionBloc.user)} minimize={this.state.minimize} onMinimize={() => this.setState({minimize: !this.state.minimize}, () => setTimeout(() => this.setState({}), 500))} />
        {this.props.children}
      </div>
    );
  }
}
